import React from 'react';
import styles from './styles.module.scss';

interface Props {
    src: string;
    label: string;
}

function Flag({
    src, label
}: Props) {
    return (
        <>
            <div className={styles.flagCont}>
                <img src={src} className={styles.img}/>
                <div className={styles.tooltip}>
                    {label}
                </div>
            </div>
        </>
    )
}

export default Flag
